var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDamages(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.504,
    height: 20.837,
    viewBox: "0 0 16.504 20.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.d{fill:none;}.b{clip-path:url(#a);}.c,.d{stroke:#aa0100;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{stroke-miterlimit:6.2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16.504,
    height: 20.837
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-299.451-208.141v13.61h-15v-19.337h9.224",
    transform: "translate(315.205 214.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-226.693-207.943h-5.58a.2.2,0,0,1-.2-.2v-5.529a.2.2,0,0,1,.2-.2l5.78,5.727A.2.2,0,0,1-226.693-207.943Z",
    transform: "translate(242.247 214.618)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamages);
export default __webpack_public_path__ + "static/media/damages.54bf4b50c297fccee829ab8a640683f5.svg";
export { ForwardRef as ReactComponent };